export default "__VITE_ASSET__7091c030__"